<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Stock Transfers'"
          :btnName="'Create New Stock Transfer'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/stock-transfer/create'"
          :btnPermission="'stock_transfer.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        ></PageTitleWithSearch>

        <DataTableWithPagination
          :headers="headers"
          :items="stockTransfers"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item }">
            <tr>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
              >
                {{ item.code }}
              </td>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
                class="text-left"
              >
                {{ item.out_branch_name }}
              </td>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
                class="text-left"
              >
                {{ item.out_store_name }}
              </td>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
                class="text-left"
              >
                {{ item.in_branch_name }}
              </td>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
                class="text-left"
              >
                {{ item.in_store_name }}
              </td>
              <td
                @click="
                  hasPermission('stock_transfer.view') &&
                    goToTransferDetails(item)
                "
                class="text-left"
              >
                {{ item.date }}
              </td>
              <td class="text-left" v-if="item.status">
                <v-chip
                  small
                  class="ma-2"
                  dark
                  :color="getStatusColor(item.status)"
                >
                  {{ stringFormatting(item.status) }}
                </v-chip>
              </td>
              <td class="text-left">
                <div
                  v-if="
                    editMode[item.uuid] && hasPermission('stock_transfer.edit')
                  "
                >
                  <v-select
                    v-model="item.newStatus"
                    :items="['Completed', 'Pending']"
                    dense
                    class="status-dropdown"
                  ></v-select>
                  <div class="d-flex align-center">
                    <v-btn
                      x-small
                      color="primary"
                      class="ma-1"
                      @click="saveStatus(item)"
                    >
                      Save
                    </v-btn>
                    <v-btn x-small class="ma-1" @click="cancelEdit(item.uuid)">
                      Cancel
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <v-btn
                    v-if="item.status === 'Pending'"
                    class="ma-1"
                    color="#FFE0B2"
                    fab
                    x-small
                    style="box-shadow: none;"
                    @click="editStatus(item)"
                  >
                    <v-icon small color="#FF9800">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    disabled
                    class="ma-1"
                    fab
                    x-small
                    style="box-shadow: none;"
                  >
                    <v-icon small color="#B0BEC5">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { StockTransferService } from "@/services/stockTransfer-service.js";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { PageTitleWithSearch, DataTableWithPagination },
  data() {
    return {
      dropId: null,
      confirmOpen: false,
      loading: true,
      stockTransfers: [],
      editMode: {},
      snackbar: false,
      successMsg: "",
      search: "",
      page: 1,
      total: 0,
      headers: [
        { text: "Transfer Code", value: "code" },
        { text: "Out Branch Name", value: "out_branch_name" },
        { text: "Out Store Name", value: "out_store_name" },
        { text: "In Branch Name", value: "in_branch_name" },
        { text: "In Store Name", value: "in_store_name" },
        { text: "Date", value: "date" },
        { text: "Status", value: "status", align: "left" },
        { text: "Actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchstockTransfers();
  },
  watch: {
    search() {
      this.fetchstockTransfers();
    },
    page() {
      this.fetchstockTransfers();
    },
  },
  methods: {
    async fetchstockTransfers() {
      this.loading = true;
      try {
        const response = await StockTransferService.getstockTransfers(
          this.search,
          this.page
        );
        this.stockTransfers = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.stockTransfers = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    editStatus(item) {
      this.$set(this.editMode, item.uuid, true);
    },
    cancelEdit(uuid) {
      this.$set(this.editMode, uuid, false);
    },
    async saveStatus(item) {
      if (item.newStatus == "Completed") {
        try {
          await StockTransferService.updateStatus(item.uuid);
          item.status = item.newStatus;
          this.successMsg = "Status updated successfully.";
          this.snackbar = true;
          this.cancelEdit(item.uuid);
          await StockTransferService.transferUpdate(item.code);
        } catch (error) {
          console.error("Failed to update status:", error);
        }
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "Completed":
          return "green";
        case "Pending":
          return "orange";
        default:
          return "grey";
      }
    },
    stringFormatting(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    searchChange(value) {
      this.search = value;
    },
    goToTransferDetails(item) {
      this.$router.push({
        name: "transferDetails",
        params: { uuid: item.uuid },
      });
    },
  },
};
</script>
